import sharedRoutes from './shared-routes'
import adminRoutes from './admin-routes'
import auditorRoutes from './auditor-routes'
import disbursementRoutes from './disbursement-routes'
import taxAccountantRoutes from './taxaccountant-routes'
import RADRoutes from './rad-routes'
import userRoutes from './user-routes'

const allRoutes = []

export default allRoutes.concat(
  sharedRoutes,
  adminRoutes,
  auditorRoutes,
  disbursementRoutes,
  taxAccountantRoutes,
  RADRoutes,
  userRoutes
)
